import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

const ATTRIBUTES: readonly ec.models.Attribute<TypeParams>[] = [
  {
    getValueFrom: report => report.label.position,
    id: 'position',
    name: '#',
  },
  {
    getValueFrom: report => report.label.code,
    id: 'code',
    name: 'Code',
  },
  {
    getValueFrom: report => report.label.name,
    id: 'name',
    name: 'Name',
  },
  {
    getValueFrom: report => report.label.faFunctionCategorization?.categoryId,
    id: 'categoryId',
    name: 'IDC Code',
  },
  {
    getValueFrom: report => ents.extra.rate.Report.Purpose.of(report.label.id),
    id: 'purpose',
    name: 'Purpose',
  },
]
// TODO: fix context variables
@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context =>
      context ? gql.queries.reportLabels.executor(context) : rxjs.of([]),
  )

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of(ATTRIBUTES)

  /** @inheritdoc */
  public get: ec.models.Api<TypeParams>['get'] = (context, id) => {
    TypeAsserter.assertIsNotNullish(context)
    return gql.queries.report.executor({ ...context, reportId: id })
  }
}
